// SourcesPanel.jsx
import React, { Component, useEffect, useRef, useState } from "react";
import NoteBookRichTextEditor from "./NoteBookRichTextEditor";
import AlertMessagePopUpModal from "../PopUp/AlertMessagePopUpModal";
import { Modal, ModalBody, ModalFooter } from "react-bootstrap";
import ModalHeader from "react-bootstrap/esm/ModalHeader";
import { AddDocGenAI } from "./PopUpGenAINoteBook/AddDocGenAI";
import { GenAiDOCIcon, GenAiPPTIcon, imsLoader } from "../../assets";
import { sanitize } from "dompurify";

const items = [
    { id: "s1", title: "Trends in health, wealth,...." },
    { id: "s2", title: "Trends in health, wealth,...." },
    { id: "s3", title: "Trends in health, wealth,...." },
];

export default function SourcesPanel(props) {
    const [attachedfile, setAttachedFile] = useState([]);
    const [checked, setChecked] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [editEnabled, setEditEnabled] = useState(false);
    const [text, setText] = useState('');
    const [notebookName, setNoteBookName] = useState('');
    const [notebookID, setNoteBookID] = useState(null);
    const [openEditor, setOpenEditor] = useState(false);
    const [alertMessageShowModal, setalertMessageShowModal] = useState(false);
    const [alertMessageContent, setalertMessageContent] = useState("")
    const [alertMessageModelColor, setalertMessageModelColor] = useState("")
    const [sourceTextView, setSourceTextView] = useState(false);
    const [editSource, setEditSource] = useState(false)
    const [openUploadPopUp, setOpenUploadPopUp] = useState(false)
    const selectAllRef = useRef(null);
    const [isEditNoteBook, setIsEditNoteBook] = useState(false)


    useEffect(() => {
        if (props.attachedFiles.length > 0) {
            setAttachedFile(props.attachedFiles)
            //setChecked(props.attachedFiles.map((x , index) => index))
            //props.handleAttachedFile(props.attachedFiles)
            //setChecked([0])
            let checkedIndex = props.attachedFiles.map((val, index) => {
                if (props.selectedFileSource?.map(x => x.name).includes(val.name)) {
                    return index
                }
            }).filter(x => x)
            setChecked(checkedIndex)
            if (selectAll) {
                let all_index = props.attachedFiles.map((x, index) => index);
                setChecked(all_index)
            } else if (localStorage.getItem('isSelectAll') === 'true') {
                let all_index = props.attachedFiles.map((x, index) => index);
                setChecked(all_index)
                setSelectAll(true)
                props.updateSelectAll(true)
                localStorage.setItem('isSelectAll', false)
            }
        } else {
            setAttachedFile([])
            setSelectAll(false)
            setChecked([])
        }
    }, [props.attachedFiles])

    useEffect(() => {
        if (props.citationTextId) {
            let sel_text = attachedfile.filter(x => x.id && x.id.toString() === props.citationTextId)[0];
            setSourceTextView(true);
            setText(sel_text.fullText)
            setNoteBookName(sel_text.name)
            setNoteBookID(sel_text.id)
            props.handleCitationTextId()
        }
    }, [props.citationTextId])

    const successAlertMessage = (message) => {
        setalertMessageContent(message)
        setalertMessageModelColor("#00c12c")
        setalertMessageShowModal(true)
    }
    const errorAlertMessage = (message) => {
        setalertMessageContent(message)
        setalertMessageModelColor("#EB1007")
        setalertMessageShowModal(true)
    }
    const closeAlertMessage = () => {
        setalertMessageContent("")
        setalertMessageModelColor("")
        setalertMessageShowModal(false)
    }

    const toggleItem = (id) => {
        let selectedAttachedFiles = attachedfile[id]
        if (checked.includes(id)) {
            let filterChecked = checked.filter(x => x !== id)
            setChecked(filterChecked)
            props.handleAttachedFile('remove', selectedAttachedFiles)
            if (filterChecked.length === 0 || filterChecked.length !== attachedfile.length) {
                setSelectAll(false)
                props.updateSelectAll(false)
            }
        } else {
            setChecked(val => [...val, id])
            props.handleAttachedFile('add', selectedAttachedFiles)
            if (checked.length === 0 && attachedfile.length === 1 || checked.length === attachedfile.length - 1) {
                setSelectAll(true)
                props.updateSelectAll(true)
            }
        }
    };
    const toggleSelectAll = (e) => {
        let arrayCheck = [];
        arrayCheck = attachedfile.map((x, index) => index);
        let selectedAttachedFiles = arrayCheck.map(x => attachedfile[x])
        if (!selectAll) {
            // for (let i = 0; i < attachedfile.length; i++) {
            //     array[i] = i
            // }
            // setChecked(array)
            // let selectedAttachedFiles = array.map(x => attachedfile[x])
            // props.handleAttachedFile('add',selectedAttachedFiles)
            setChecked(arrayCheck);
            setSelectAll(true);
            props.updateSelectAll(true)
            props.handleAttachedFile('add', selectedAttachedFiles)
        } else {
            setChecked([])
            setSelectAll(false)
            props.handleAttachedFile('remove', selectedAttachedFiles)
            props.updateSelectAll(false)
        }
    };
    const renderFileIcon = (name) => {
        if (name.toLowerCase().endsWith('.pdf')) {
            return (<> <svg width="20px" height="20px" viewBox="-4 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0">
            </g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier"> <path d="M25.6686 26.0962C25.1812 26.2401 24.4656 26.2563 23.6984 26.145C22.875 26.0256 22.0351 25.7739 21.2096 25.403C22.6817 25.1888 23.8237 25.2548 24.8005 25.6009C25.0319 25.6829 25.412 25.9021 25.6686 26.0962ZM17.4552 24.7459C17.3953 24.7622 17.3363 24.7776 17.2776 24.7939C16.8815 24.9017 16.4961 25.0069 16.1247 25.1005L15.6239 25.2275C14.6165 25.4824 13.5865 25.7428 12.5692 26.0529C12.9558 25.1206 13.315 24.178 13.6667 23.2564C13.9271 22.5742 14.193 21.8773 14.468 21.1894C14.6075 21.4198 14.7531 21.6503 14.9046 21.8814C15.5948 22.9326 16.4624 23.9045 17.4552 24.7459ZM14.8927 14.2326C14.958 15.383 14.7098 16.4897 14.3457 17.5514C13.8972 16.2386 13.6882 14.7889 14.2489 13.6185C14.3927 13.3185 14.5105 13.1581 14.5869 13.0744C14.7049 13.2566 14.8601 13.6642 14.8927 14.2326ZM9.63347 28.8054C9.38148 29.2562 9.12426 29.6782 8.86063 30.0767C8.22442 31.0355 7.18393 32.0621 6.64941 32.0621C6.59681 32.0621 6.53316 32.0536 6.44015 31.9554C6.38028 31.8926 6.37069 31.8476 6.37359 31.7862C6.39161 31.4337 6.85867 30.8059 7.53527 30.2238C8.14939 29.6957 8.84352 29.2262 9.63347 28.8054ZM27.3706 26.1461C27.2889 24.9719 25.3123 24.2186 25.2928 24.2116C24.5287 23.9407 23.6986 23.8091 22.7552 23.8091C21.7453 23.8091 20.6565 23.9552 19.2582 24.2819C18.014 23.3999 16.9392 22.2957 16.1362 21.0733C15.7816 20.5332 15.4628 19.9941 15.1849 19.4675C15.8633 17.8454 16.4742 16.1013 16.3632 14.1479C16.2737 12.5816 15.5674 11.5295 14.6069 11.5295C13.948 11.5295 13.3807 12.0175 12.9194 12.9813C12.0965 14.6987 12.3128 16.8962 13.562 19.5184C13.1121 20.5751 12.6941 21.6706 12.2895 22.7311C11.7861 24.0498 11.2674 25.4103 10.6828 26.7045C9.04334 27.3532 7.69648 28.1399 6.57402 29.1057C5.8387 29.7373 4.95223 30.7028 4.90163 31.7107C4.87693 32.1854 5.03969 32.6207 5.37044 32.9695C5.72183 33.3398 6.16329 33.5348 6.6487 33.5354C8.25189 33.5354 9.79489 31.3327 10.0876 30.8909C10.6767 30.0029 11.2281 29.0124 11.7684 27.8699C13.1292 27.3781 14.5794 27.011 15.985 26.6562L16.4884 26.5283C16.8668 26.4321 17.2601 26.3257 17.6635 26.2153C18.0904 26.0999 18.5296 25.9802 18.976 25.8665C20.4193 26.7844 21.9714 27.3831 23.4851 27.6028C24.7601 27.7883 25.8924 27.6807 26.6589 27.2811C27.3486 26.9219 27.3866 26.3676 27.3706 26.1461ZM30.4755 36.2428C30.4755 38.3932 28.5802 38.5258 28.1978 38.5301H3.74486C1.60224 38.5301 1.47322 36.6218 1.46913 36.2428L1.46884 3.75642C1.46884 1.6039 3.36763 1.4734 3.74457 1.46908H20.263L20.2718 1.4778V7.92396C20.2718 9.21763 21.0539 11.6669 24.0158 11.6669H30.4203L30.4753 11.7218L30.4755 36.2428ZM28.9572 10.1976H24.0169C21.8749 10.1976 21.7453 8.29969 21.7424 7.92417V2.95307L28.9572 10.1976ZM31.9447 36.2428V11.1157L21.7424 0.871022V0.823357H21.6936L20.8742 0H3.74491C2.44954 0 0 0.785336 0 3.75711V36.2435C0 37.5427 0.782956 40 3.74491 40H28.2001C29.4952 39.9997 31.9447 39.2143 31.9447 36.2428Z" fill="#f30d05"></path> </g>
            </svg></>)
        }
        else if (name.toLowerCase().endsWith('.doc') || name.toLowerCase().endsWith('.docx')) {
            return (<><img height={20} width={20} src={GenAiDOCIcon} /> &nbsp;</>)
        }
        else if (name.toLowerCase().endsWith('.ppt') || name.toLowerCase().endsWith('.pptx')) {
            return (<><img height={20} width={20} src={GenAiPPTIcon} /> &nbsp;</>)
        }
        else if (name.toLowerCase().endsWith('.jpg')
            || name.toLowerCase().endsWith('.jpeg')
            || name.toLowerCase().endsWith('.png')
            || name.toLowerCase().endsWith('.gif')) {
            return (<><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="miter">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                    <polygon points="22 15.5 17 10 10.59 16.99 6.5 13 2 17.5 2 22 22 22 22 15.5" stroke-width="0" fill="#059cf7" opacity="0.1"></polygon>
                    <polygon points="22 15.5 17 10 10.59 16.99 6.5 13 2 17.5 2 22 22 22 22 15.5"></polygon>
                    <rect x="2" y="2" width="20" height="20" rx="0"></rect>
                    <line x1="6.99" y1="7" x2="7" y2="7" stroke-linecap="round" stroke-width="2"></line>
                </g>
            </svg> &nbsp;</>)
        }
        else {
            return (<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="file" class="svg-inline--fa fa-file fa-fw fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"></path></svg>)
        }
    }
    const handleOnClickView = (index, x) => {
        if (attachedfile[index] && (attachedfile[index].type === 'application/pdf' || attachedfile[index].type?.startsWith('image'))) {
            // const pdfUrl = URL.createObjectURL(attachedfile[index]);
            // window.open(pdfUrl, "_blank")
            props.handleClickOnCitationNumber(attachedfile[index].guid, [1])
            //handleSaveInS3(index , attachedfile[index])
        } else {
            setSourceTextView(true);
            setText(x.fullText)
            setNoteBookName(x.name)
            setNoteBookID(x.id)
        }
    }
    const onClickAdd = () => {
        setOpenUploadPopUp(true)
    }

    const handleEditSourceText = (index, x) => {
        if (x.name.toLowerCase().endsWith('.txt')) {
            setEditSource(true);
            setSourceTextView(true);
            setText(x.fullText);
            setNoteBookName(x.name);
            setNoteBookID(x.id);
            setIsEditNoteBook(true)
        } else {
            props.handleDeleteFilesSoureces(index, attachedfile[index])
        }
    }
    const handleDeleteTxtSoureces = (index, x) => {
        props.handleDeleteTxtSoureces(index, attachedfile[index])
    }

    const handleClose = () => {
        setSourceTextView(false)
        setEditSource(false)
        setIsEditNoteBook(false)
    }
    const handleApplyChangesOnSourceText = () => {
        if (text) {
            props.updateSourceTextOfDb(text, notebookID, notebookName);
            setEditSource(false)
            setIsEditNoteBook(false)
            setSourceTextView(false)
        } else {
            errorAlertMessage('Empty text cannot be saved.')
        }
    }
    const getCleanText = (summary) => {
        let cleanText = summary.replace(/<[^>]*>/g, '');
        return cleanText
    }
    return (
        <section className="sources-panel" aria-labelledby="sources-title">
            <header className="sources-header">
                <div className="header-left">
                    <div className="header-icon" aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                            <path d="M12.8334 2.08041V5.86674C12.8334 6.38012 12.8334 6.63681 12.9333 6.83289C13.0212 7.00537 13.1614 7.14561 13.3339 7.23349C13.53 7.3334 13.7867 7.3334 14.3001 7.3334H18.0864M12.8334 15.5833H7.33341M14.6667 11.9167H7.33341M18.3334 9.15588V15.7667C18.3334 17.3068 18.3334 18.0769 18.0337 18.6651C17.77 19.1826 17.3493 19.6033 16.8319 19.8669C16.2436 20.1667 15.4736 20.1667 13.9334 20.1667H8.06675C6.5266 20.1667 5.75653 20.1667 5.16827 19.8669C4.65083 19.6033 4.23013 19.1826 3.96648 18.6651C3.66675 18.0769 3.66675 17.3068 3.66675 15.7667V6.23334C3.66675 4.69319 3.66675 3.92312 3.96648 3.33486C4.23013 2.81742 4.65083 2.39672 5.16827 2.13307C5.75653 1.83334 6.5266 1.83334 8.06675 1.83334H11.0109C11.6835 1.83334 12.0198 1.83334 12.3363 1.90932C12.6169 1.97668 12.8851 2.0878 13.1312 2.23858C13.4087 2.40864 13.6465 2.64645 14.1221 3.12207L17.0447 6.0446C17.5203 6.52022 17.7581 6.75803 17.9282 7.03555C18.079 7.2816 18.1901 7.54985 18.2574 7.83045C18.3334 8.14694 18.3334 8.48325 18.3334 9.15588Z" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <h2 id="sources-title" className="title">Sources</h2>
                </div>
                <div className='source-header-divider'>
                    <div className="source-divider"></div>
                </div>
            </header>
            {(props.leftIsProcessing) ? <div className="mg-tp-12"><img src={imsLoader} alt="" width={50} /></div> : <div className="mg-tp-12"> <div className="header-actions">
                {/* <input type="file" name="pdfUploadFile" id="pdfUploadFile" accept=".pdf, .xls, .xlsx" onChange={onClickAdd} style={{ display: 'none' }} />
                    <label for='pdfUploadFile' className="source-btn" type="button" aria-label="Add source">
                        <span className="btn-icon" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <g clip-path="url(#clip0_595_624)">
                                    <path d="M13.3328 6.99999V4.53333C13.3328 3.41322 13.3328 2.85317 13.1148 2.42535C12.9231 2.04902 12.6171 1.74306 12.2408 1.55132C11.813 1.33333 11.253 1.33333 10.1329 1.33333H5.86639C4.74633 1.33333 4.18629 1.33333 3.75848 1.55132C3.38217 1.74306 3.07622 2.04902 2.88448 2.42535C2.6665 2.85317 2.6665 3.41322 2.6665 4.53333V11.4667C2.6665 12.5868 2.6665 13.1468 2.88448 13.5746C3.07622 13.951 3.38217 14.2569 3.75848 14.4487C4.18629 14.6667 4.74633 14.6667 5.86639 14.6667H7.99965M9.33294 7.33333H5.33308M6.66636 9.99999H5.33308M10.6662 4.66666H5.33308M11.9995 14V9.99999M9.99958 12H13.9994" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_595_624">
                                        <rect width="15.9994" height="16" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </span>
                        <span className="btn-text">Add</span>
                    </label> */}
                {<div className="source-btn" type="button" aria-label="Add source" onClick={onClickAdd}>
                    <span className="btn-icon" aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <g clip-path="url(#clip0_595_624)">
                                <path d="M13.3328 6.99999V4.53333C13.3328 3.41322 13.3328 2.85317 13.1148 2.42535C12.9231 2.04902 12.6171 1.74306 12.2408 1.55132C11.813 1.33333 11.253 1.33333 10.1329 1.33333H5.86639C4.74633 1.33333 4.18629 1.33333 3.75848 1.55132C3.38217 1.74306 3.07622 2.04902 2.88448 2.42535C2.6665 2.85317 2.6665 3.41322 2.6665 4.53333V11.4667C2.6665 12.5868 2.6665 13.1468 2.88448 13.5746C3.07622 13.951 3.38217 14.2569 3.75848 14.4487C4.18629 14.6667 4.74633 14.6667 5.86639 14.6667H7.99965M9.33294 7.33333H5.33308M6.66636 9.99999H5.33308M10.6662 4.66666H5.33308M11.9995 14V9.99999M9.99958 12H13.9994" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_595_624">
                                    <rect width="15.9994" height="16" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </span>
                    <span className="btn-text">Add</span>
                </div>}
                {/* <button className="source-btn" type="button" aria-label="Discover sources">
                    <span className="btn-icon" aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <g clip-path="url(#clip0_595_628)">
                                <path d="M9.33294 7.33333H5.33308M6.66636 9.99999H5.33308M10.6662 4.66666H5.33308M13.3328 6.99999V4.53333C13.3328 3.41322 13.3328 2.85317 13.1148 2.42535C12.9231 2.04902 12.6171 1.74306 12.2408 1.55132C11.813 1.33333 11.253 1.33333 10.1329 1.33333H5.86639C4.74633 1.33333 4.18629 1.33333 3.75848 1.55132C3.38217 1.74306 3.07622 2.04902 2.88448 2.42535C2.6665 2.85317 2.6665 3.41322 2.6665 4.53333V11.4667C2.6665 12.5868 2.6665 13.1468 2.88448 13.5746C3.07622 13.951 3.38217 14.2569 3.75848 14.4487C4.18629 14.6667 4.74633 14.6667 5.86639 14.6667H7.66633M14.6661 14.6667L13.6661 13.6667M14.3328 12C14.3328 13.2887 13.2881 14.3333 11.9995 14.3333C10.7109 14.3333 9.66626 13.2887 9.66626 12C9.66626 10.7113 10.7109 9.66666 11.9995 9.66666C13.2881 9.66666 14.3328 10.7113 14.3328 12Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_595_628">
                                    <rect width="15.9994" height="16" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </span>
                    <span className="btn-text">Discover</span>
                </button> */}
            </div><div className="sources-controls">
                    <label className="select-all">
                        <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={toggleSelectAll}
                            aria-label="Select all sources"
                        />
                        <span className="checkbox-custom" aria-hidden="true">
                            <span className="check-mark"></span>
                        </span>
                        <span className="select-all-text">Select All</span>
                    </label>
                </div>

                <ul className="sources-list" role="list" aria-labelledby="sources-title">
                    {attachedfile.map((item, index) => {
                        return (
                            <li className="source-item">
                                <div className="item-left">
                                    <label className="item-checkbox" aria-label={`Select ${item.name}`}>
                                        <input
                                            type="checkbox"
                                            checked={checked.indexOf(index) !== -1}
                                            onChange={() => toggleItem(index)}
                                        />
                                        <span className="checkbox-custom" aria-hidden="true">
                                            <span className="check-mark"></span>
                                        </span>
                                    </label>

                                    <div className="item-meta">
                                        <div className="item-avatar" aria-hidden="true">
                                            {(item.fullText) ? <>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 22 22" fill="none"><g clip-path="url(#clip0_309_9262)"><path d="M12.8334 10.0833H7.33341M9.16675 13.75H7.33341M14.6667 6.41666H7.33341M18.3334 6.23333V15.7667C18.3334 17.3068 18.3334 18.0769 18.0337 18.6651C17.77 19.1826 17.3493 19.6033 16.8319 19.8669C16.2436 20.1667 15.4736 20.1667 13.9334 20.1667H8.06675C6.5266 20.1667 5.75653 20.1667 5.16827 19.8669C4.65083 19.6033 4.23013 19.1826 3.96648 18.6651C3.66675 18.0769 3.66675 17.3068 3.66675 15.7667V6.23333C3.66675 4.69318 3.66675 3.92311 3.96648 3.33485C4.23013 2.81741 4.65083 2.39671 5.16827 2.13306C5.75653 1.83333 6.5266 1.83333 8.06675 1.83333H13.9334C15.4736 1.83333 16.2436 1.83333 16.8319 2.13306C17.3493 2.39671 17.77 2.81741 18.0337 3.33485C18.3334 3.92311 18.3334 4.69318 18.3334 6.23333Z" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_309_9262"><rect width="22" height="22" fill="white"></rect></clipPath></defs></svg>
                                            </> : renderFileIcon(item.name)}
                                        </div>
                                        <div className="item-title">{item.name}</div>
                                    </div>
                                </div>

                                <div className="item-actions">
                                    <button className="icon-btn" type="button" aria-label={`View ${item.name}`}
                                        onClick={() => { (item.name.toLowerCase().endsWith('.txt')) ? handleEditSourceText(index, item) : handleOnClickView(index, item) }}>

                                        {(item.name.toLowerCase().endsWith('.txt')) ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <g clip-path="url(#clip0_595_669)">
                                                <path d="M1.91719 12.0771C1.94782 11.8014 1.96313 11.6636 2.00483 11.5348C2.04183 11.4205 2.09411 11.3117 2.16024 11.2114C2.23479 11.0984 2.33284 11.0003 2.52896 10.8042L11.3328 2.00001C12.0692 1.26363 13.2631 1.26363 13.9994 2.00001C14.7358 2.73639 14.7358 3.9303 13.9994 4.66668L5.19553 13.4709C4.99942 13.667 4.90136 13.765 4.78832 13.8396C4.68803 13.9057 4.57926 13.958 4.46497 13.995C4.33615 14.0367 4.19832 14.052 3.92267 14.0826L1.6665 14.3333L1.91719 12.0771Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_595_669">
                                                    <rect width="15.9994" height="16" rx="4" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg> :
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 16 16" fill="none">
                                                <g clip-path="url(#clip0_595_664)">
                                                    <path d="M1.61341 8.47546C1.52262 8.3317 1.47723 8.25982 1.45182 8.14895C1.43273 8.06568 1.43273 7.93434 1.45182 7.85107C1.47723 7.7402 1.52262 7.66832 1.61341 7.52456C2.36365 6.33657 4.59682 3.33334 8.00004 3.33334C11.4033 3.33334 13.6364 6.33657 14.3867 7.52456C14.4775 7.66832 14.5228 7.7402 14.5483 7.85107C14.5673 7.93434 14.5673 8.06568 14.5483 8.14895C14.5228 8.25982 14.4775 8.3317 14.3867 8.47546C13.6364 9.66345 11.4033 12.6667 8.00004 12.6667C4.59682 12.6667 2.36365 9.66345 1.61341 8.47546Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M8.00004 10C9.10457 10 9.99997 9.10458 9.99997 8.00001C9.99997 6.89544 9.10457 6.00001 8.00004 6.00001C6.89551 6.00001 6.00011 6.89544 6.00011 8.00001C6.00011 9.10458 6.89551 10 8.00004 10Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_595_664">
                                                        <rect width="15.9994" height="16" rx="4" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        }
                                    </button>
                                    <button className={"icon-btn editHover"}
                                        type="button"
                                        aria-label={`Edit ${item.name}`}
                                        onClick={() => (item.name.toLowerCase().endsWith('.txt')) ? handleDeleteTxtSoureces(index, item) : handleEditSourceText(index, item)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M4.75 0.75H8.75M0.75 2.75H12.75M11.4167 2.75L10.9491 9.76286C10.879 10.815 10.8439 11.3411 10.6167 11.74C10.4166 12.0912 10.1148 12.3735 9.75111 12.5498C9.33798 12.75 8.81073 12.75 7.75623 12.75H5.74377C4.68927 12.75 4.16202 12.75 3.74889 12.5498C3.38517 12.3735 3.08339 12.0912 2.88332 11.74C2.65607 11.3411 2.621 10.815 2.55086 9.76286L2.08333 2.75M5.41667 5.75V9.08333M8.08333 5.75V9.08333" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                    </button>
                                </div>
                            </li>
                        )
                    })}
                </ul></div>}
            {<Modal
                show={sourceTextView}
                onHide={() => { setSourceTextView(false) }}
                className="source-text-bottom-modal-outer"
                dialogClassName="source-text-bottom-modal"
                contentClassName="source-text-bottom-modal-content"
                centered={false}
            >
                <ModalHeader>
                    <div style={{ display: 'flex', gap: '13px', color: '#EB1700', alignItems: 'center' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none"><g clip-path="url(#clip0_309_9262)"><path d="M12.8334 10.0833H7.33341M9.16675 13.75H7.33341M14.6667 6.41666H7.33341M18.3334 6.23333V15.7667C18.3334 17.3068 18.3334 18.0769 18.0337 18.6651C17.77 19.1826 17.3493 19.6033 16.8319 19.8669C16.2436 20.1667 15.4736 20.1667 13.9334 20.1667H8.06675C6.5266 20.1667 5.75653 20.1667 5.16827 19.8669C4.65083 19.6033 4.23013 19.1826 3.96648 18.6651C3.66675 18.0769 3.66675 17.3068 3.66675 15.7667V6.23333C3.66675 4.69318 3.66675 3.92311 3.96648 3.33485C4.23013 2.81741 4.65083 2.39671 5.16827 2.13306C5.75653 1.83333 6.5266 1.83333 8.06675 1.83333H13.9334C15.4736 1.83333 16.2436 1.83333 16.8319 2.13306C17.3493 2.39671 17.77 2.81741 18.0337 3.33485C18.3334 3.92311 18.3334 4.69318 18.3334 6.23333Z" stroke="#EB1700" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_309_9262"><rect width="22" height="22" fill="white"></rect></clipPath></defs></svg>
                        {(!isEditNoteBook) ? <div title="click to edit file name" onClick={() => { setIsEditNoteBook(true) }}>{notebookName}</div> :
                            <input className="source-text-name" placeholder={notebookName} type="text" onChange={(e) => setNoteBookName(`${e.target.value}.txt`)} />
                        }
                        {!editSource && <span className="span-button" onClick={() => setEditSource(true)}><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M19.7587 9.25375L18.9062 8.40125L18.7893 8.28437L15.1318 11.9419L13.0762 9.88625L16.7337 6.22875L16.2524 5.7475L15.8262 5.32125L15.7574 5.2525L12.0999 8.91L10.0718 6.875L13.7293 3.2175L13.6055 3.09375L12.753 2.24125L8.54555 6.44875L8.43555 6.60687L2.24805 18.7825L3.21742 19.7519L15.4137 13.5575L15.5718 13.4475L19.7587 9.25375ZM8.60742 15.4687C7.82367 15.8675 7.34242 16.1081 6.78555 15.5512L6.55867 15.3244L6.32492 15.0975C5.88492 14.6506 6.13242 14.1831 6.5243 13.3925L9.26055 8.01625L13.9905 12.7462L8.60742 15.4687Z" fill="black"></path></svg>
                        </span>}
                    </div>
                    <div style={{ cursor: 'pointer' }} onClick={() => handleClose()}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>
                </ModalHeader>
                <ModalBody>
                    <div className="modal-content-source-text">
                        {(!editSource) ? <div dangerouslySetInnerHTML={{ __html: sanitize(text) }}></div> :
                            <textarea className="notebook-genai-info"
                                value={getCleanText(text)}
                                onChange={(e) => setText(e.target.value)} />}
                    </div>
                </ModalBody>
                <ModalFooter>
                    {editSource && <>
                        <div className={"GenAIAuthoring-div-label pd-none create-draft"} style={{ fontWeight: '400', fontSize: '16px' }} onClick={() => { handleApplyChangesOnSourceText(); }}>Apply Changes</div>
                        <div className={"GenAIAuthoring-div-label pd-none create-draft"} style={{ fontWeight: '400', fontSize: '16px' }} onClick={() => handleClose()}>Cancel</div>
                    </>}
                </ModalFooter>
            </Modal>}
            {(openEditor) && <NoteBookRichTextEditor
                showModal={openEditor}
                selectedSummary={text}
                summaryId={''}
                handleClose={() => setOpenEditor(false)}
                selectedNotebookName={notebookName}
                updateSummary={() => { }}
                deleteSummary={() => { }}
                handleAddToSource={() => { }}
                handeAddToNotes={() => { }}
                handleUpdateNotes={() => { }}
                handleDeleteNotes={() => { }}
                isSummary={false}
                isNotes={false}
                isEditSourceText={true} />}
            {alertMessageShowModal && <AlertMessagePopUpModal
                color={alertMessageModelColor}
                content={alertMessageContent}
                showModal={alertMessageShowModal}
                handleClose={() => closeAlertMessage()} />}
            {openUploadPopUp && <AddDocGenAI
                showModal={openUploadPopUp}
                attachedFiles={attachedfile}
                projectTitle={props.notebookTitle}
                handleAttachedFiles={props.handleAttachedFiles}
                currentSessionID={props.currentSessionID}
                handleClose={(val) => setOpenUploadPopUp(false)} />}
        </section>
    );
}
